import React, { useState } from 'react'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import NewActionMenu from 'components/ContentBox/Global/ActionMenu/ActionMenu'
import styles from './Programm.module.scss'

export const Programm = ({ program, index, action }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const menu = [
    { name: 'Edit', action: 'edit' },
    { name: 'Delete', action: 'delete' },
  ]

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} ${expanded && styles.colorBgActive}`}
      >
        <div className={styles.containerInf}>
          <div
            className={`${styles.infStyl} ${styles.name} ${expanded ? styles.expClr : styles.notExpClr}`}
          >
            {program.name}
          </div>
          <div className={styles.buttons}>
            <NewActionMenu variant='simple' onSimpleAction={toggleExpand} />
            <ActionMenu
              menu={menu}
              action={action}
              items={{
                name: program.name,
                company: program.id,
              }}
            />
          </div>
        </div>
      </div>
      {expanded && (
        <div className={styles.clientDetails}>
          <div className={`${styles.formField} `}>
            <div className={styles.label}>Programm:</div>
            <div className={styles.info}>{program.name}</div>
          </div>
          <div className={`${styles.formField}`}>
            <div className={styles.label}>Company:</div>
            <div className={styles.info}>{program.company}</div>
          </div>
        </div>
      )}
    </>
  )
}
